import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useRecoilValue } from "recoil";
import authAtom from "stores/auth";

// 로그인 인증 라우터 레이아웃
const AuthRoute = () => {
  const { isLogin } = useRecoilValue(authAtom);

  useEffect(() => {
    if (!isLogin) {
      window.location.href = "/login";
    }
  }, []);

  return <Outlet />;
};

export default AuthRoute;
